import {useEffect} from "react";
import {Hub} from "aws-amplify/utils";
import {loginAudit} from "../../api/requests/partner-level/loginAudit";

export const useAuthListener = () => {
  useEffect(() => {
    const unsubscribe = Hub.listen("auth", (data) => {
      if (data.payload.event === "signedIn") {
        // @ts-ignore
        const signInDetails = data.payload.data.signInDetails;
        const username = data.payload.data.username;
        loginAudit({
          username,
          signInDetails: {authFlowType: signInDetails?.authFlowType || "SAML", loginId: signInDetails?.loginId},
        });
        console.log("User signed in:", data);
      }
    });

    return () => unsubscribe();
  }, []);
  return null;
};
